import React from "react";
import "./Bookmark.scss";

const Bookmark = () => {
  return <div className="primary bookmark">Bookmark</div>;
};

export default Bookmark;
